import React, { useEffect, useState } from 'react'
import { Link } from "react-router-dom";
import style from './Employee.module.scss'

export default function Employee( {firstName, lastName, img} ) {
    const nameEmplo = `${firstName}-${lastName}`;
    const url = "https://sqn-law.ru:3001"

    return (
        <>
            <Link className={style.employee} to={`/team/${nameEmplo}`}>
                <div className={style.img}><img src={`${url}${img?.url}`} alt='Name'/>
                    <span className={style.line}></span></div>
                <div className={style.nameContainer}>
                    <h4 className={style.name}>{firstName}</h4>
                    <h4 className={style.name}>{lastName}</h4>
                </div>
            </Link>
        </>
    )
}
